export const GET_INVOICE_JOURNAL_LIST = 'GET_INVOICE_JOURNAL_LIST';
export const GET_INVOICE_JOURNAL = 'GET_INVOICE_JOURNAL';
export const CREATE_INVOICE_JOURNAL = 'CREATE_INVOICE_JOURNAL';
